import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ModalController, IonContent } from '@ionic/angular';
import { PortalProveedorService } from '../../../services/api.services';

@Component({
  selector: 'app-add-comentario-modal',
  templateUrl: './add-comentario-modal.component.html',
  styleUrls: ['./add-comentario-modal.component.scss'],
})
export class AddComentarioModalComponent implements OnInit, AfterViewInit {

  @Input() isModal;
  @Input() comment;
  @ViewChild('content') private content: IonContent;
  commentToSend = '';
  operatorIdSelected: number;
  arrayComentarios: string[] = [];

  constructor(private modalCtrl: ModalController,
              private portalProveedorService: PortalProveedorService) { }

  ngAfterViewInit(): void {
    this.scrollToBottomOnInit();
  }

  ngOnInit() {
    this.operatorIdSelected = this.portalProveedorService.getOperatorSel();
    this.arrayComentarios = this.comment.split('\n');
  }

  enviar() {
    this.modalCtrl.dismiss(
      {
        commentToSend: this.commentToSend,
        operatorIdSelected: this.operatorIdSelected
      }
    );
  }

  scrollToBottomOnInit() {
    setTimeout(() => {
      this.content.scrollToBottom(300);
    }, 500);
  }
}
